<template>
  <div>
    <v-tabs
      :ripple="false"
      v-model="selectedTab"
      slider-color="dinamo"
      background-color="transparent"
      centered
      show-arrows
      mobile-break-point="100px"
    >
      <v-tab v-for="tab in tabs" :id="`tab_${tab.id}`" :key="`tab-${tab.id}`">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item class="mt-4">
        <simple-blocks />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <key-monitor />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <object-monitor />
      </v-tab-item>

      <!-- <v-tab-item class="mt-4">
        <global-monitor-page />
      </v-tab-item> -->
    </v-tabs-items>
  </div>
</template>

<script>
// import GlobalMonitorPage from './GlobalMonitorPage.vue'
import KeyMonitor from './KeyMonitor.vue'
import ObjectMonitor from './ObjectMonitor.vue'
import SimpleBlocks from './SimpleBlocks.vue'

export default {
  components: {
    SimpleBlocks,
    KeyMonitor,
    ObjectMonitor
    // GlobalMonitorPage
  },
  created () {
    if (this.parameterSelect !== undefined) {
      this.selectedTab = this.parameterSelect - 3
    }
  },
  data () {
    return {
      selectedTab: 0
    }
  },
  computed: {
    tabs () {
      return [
        {
          title: this.$tc('general'),
          id: 'general'
        },
        {
          title: this.$tc('crypto'),
          id: 'crypto_monitor'
        },
        {
          title: this.$tc('stats'),
          id: 'stats_monitor'
        }
        // {
        //   title: this.$tc('global_monitor'),
        //   id: 'global_monitor'
        // }
      ]
    },
    parameterSelect () {
      return this.$route.params.selectedTab
    }
  },
  methods: {}
}
</script>
<style>

.theme--light.v-tabs-items {
  background-color: transparent;
}
.theme--dark.v-tabs-items {
  background-color: transparent;
}

</style>
